var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CContainer',[_c('h6',[_vm._v(" Esta sección le permite conocer el Catálogo de Productos que ofrece el proveedor a la empresa. En este catálogo puede ver en detalle los productos y sus carácteristicas. ")]),_c('ImageGallery',{attrs:{"cartMode":false,"data":_vm.products}}),(_vm.loading)?_c('CElementCover'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }